var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-form",
    { ref: "formActivity", attrs: { "lazy-validation": "" } },
    [
      _c(
        "v-radio-group",
        {
          staticClass: "justify-center items-center align-center mt-0 px-2",
          style: { height: "40px" },
          attrs: { row: "" },
          model: {
            value: _vm.comment.type,
            callback: function ($$v) {
              _vm.$set(_vm.comment, "type", $$v)
            },
            expression: "comment.type",
          },
        },
        [
          _vm._l(_vm.commentTypesFiltered, function (type, i) {
            return [
              type.allow_user
                ? _c("v-radio", {
                    key: i,
                    staticClass: "px-2",
                    attrs: {
                      color: type.color,
                      value: type.id,
                      selected: "",
                      "on-icon": type.icon,
                      "off-icon": type.icon,
                    },
                  })
                : _vm._e(),
            ]
          }),
        ],
        2
      ),
      _vm._v(" "),
      _vm.comment.type === _vm.$activityTypes.WHATSAPP
        ? _c(
            "v-col",
            [
              _vm.getTicket.wa_response
                ? _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "py-0 d-flex justify-end",
                          attrs: { cols: "12" },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                loading: _vm.loadingMarkAsRead,
                                color: "primary",
                                "x-small": "",
                                outlined: "",
                                dark: "",
                              },
                              on: { click: _vm.markAsRead },
                            },
                            [_vm._v("\n          Marcar como leído\n        ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.getTicket.is_bot_stopped
                ? _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { staticClass: "text-center", attrs: { cols: "12" } },
                        [
                          _c("p", { staticClass: "mb-2" }, [
                            _vm._v(
                              "Bot de Whatsapp activo en esta conversación"
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                loading: _vm.loadingHandleWhatsappBotStatus,
                                color: "primary",
                                rounded: "",
                                small: "",
                              },
                              on: { click: _vm.onHandleWhatsappBotStatus },
                            },
                            [_vm._v("\n          Desactivar bot\n        ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.getTicket.is_bot_stopped && _vm.getBusiness.use_ia
                ? _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { staticClass: "text-center", attrs: { cols: "12" } },
                        [
                          _c("p", { staticClass: "mb-2" }, [
                            _vm._v(
                              "Bot de Whatsapp detenido en esta conversación"
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                loading: _vm.loadingHandleWhatsappBotStatus,
                                color: "primary",
                                rounded: "",
                                small: "",
                              },
                              on: { click: _vm.onHandleWhatsappBotStatus },
                            },
                            [_vm._v("\n          Activar bot\n        ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.getTicket.is_bot_stopped
                ? _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("v-select", {
                            attrs: {
                              rules: [_vm.$rules.REQUIRED],
                              items: _vm.getWhatsAppApps,
                              "item-text": (item) =>
                                `${item.verified_name} (${item.display_phone_number})`,
                              "item-value": "id",
                              label: "Responder desde",
                              "return-object": "",
                            },
                            model: {
                              value: _vm.whatsappApp,
                              callback: function ($$v) {
                                _vm.whatsappApp = $$v
                              },
                              expression: "whatsappApp",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        { staticClass: "py-0 d-flex", attrs: { cols: "12" } },
                        [
                          _c(
                            "div",
                            { staticClass: "my-auto" },
                            [
                              _c("v-checkbox", {
                                staticClass: "my-0 py-0",
                                style: { height: "24px" },
                                attrs: {
                                  label: "Enviar plantilla de mensaje",
                                  color: "accent",
                                  "hide-details": "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.onCheckWhatsappMessageTemplate(
                                      $event
                                    )
                                  },
                                },
                                model: {
                                  value: _vm.useMessageTemplate,
                                  callback: function ($$v) {
                                    _vm.useMessageTemplate = $$v
                                  },
                                  expression: "useMessageTemplate",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-speed-dial",
                            {
                              staticClass: "speed-dial-custom",
                              attrs: {
                                top: true,
                                right: true,
                                direction: "bottom",
                                "open-on-hover": true,
                                transition: "slide-y-transition",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function () {
                                      return [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: { icon: "" },
                                            model: {
                                              value: _vm.fab,
                                              callback: function ($$v) {
                                                _vm.fab = $$v
                                              },
                                              expression: "fab",
                                            },
                                          },
                                          [
                                            _vm.fab
                                              ? _c(
                                                  "v-icon",
                                                  { attrs: { small: "" } },
                                                  [_vm._v(" fa fa-times ")]
                                                )
                                              : _c(
                                                  "v-icon",
                                                  { attrs: { small: "" } },
                                                  [_vm._v(" fas fa-paperclip ")]
                                                ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                3034107207
                              ),
                              model: {
                                value: _vm.fab,
                                callback: function ($$v) {
                                  _vm.fab = $$v
                                },
                                expression: "fab",
                              },
                            },
                            [
                              _vm._v(" "),
                              ["image", "document", "upload"].includes(
                                _vm.whatsappMessageType
                              )
                                ? _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        fab: "",
                                        dark: "",
                                        small: "",
                                        color: "accent",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onChangeWhatsAppMessageType(
                                            "text"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("v-icon", { attrs: { small: "" } }, [
                                        _vm._v("fas fa-align-center"),
                                      ]),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    fab: "",
                                    dark: "",
                                    small: "",
                                    color: "purple",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onChangeWhatsAppMessageType(
                                        "image"
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("v-icon", { attrs: { small: "" } }, [
                                    _vm._v("fas fa-image"),
                                  ]),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    fab: "",
                                    dark: "",
                                    small: "",
                                    color: "indigo",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onChangeWhatsAppMessageType(
                                        "document"
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("v-icon", { attrs: { small: "" } }, [
                                    _vm._v("fas fa-file"),
                                  ]),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    fab: "",
                                    dark: "",
                                    small: "",
                                    color: "orange",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onChangeWhatsAppMessageType(
                                        "upload"
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("v-icon", { attrs: { small: "" } }, [
                                    _vm._v("fas fa-upload"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.useMessageTemplate
                        ? _c(
                            "v-col",
                            { staticClass: "d-flex", attrs: { cols: "12" } },
                            [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.whatsAppMessageTemplatesFiltered,
                                  rules: [_vm.$rules.REQUIRED],
                                  label: "Plantilla de mensaje",
                                  "item-value": "id",
                                  "item-text": "name",
                                },
                                model: {
                                  value: _vm.whatsappMessageTemplate,
                                  callback: function ($$v) {
                                    _vm.whatsappMessageTemplate = $$v
                                  },
                                  expression: "whatsappMessageTemplate",
                                },
                              }),
                              _vm._v(" "),
                              _vm.whatsappMessageTemplate
                                ? _c(
                                    "v-btn",
                                    {
                                      staticClass: "ml-2 my-auto",
                                      attrs: { text: "", icon: "" },
                                      on: { click: _vm.onOpenModalPreview },
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { dark: "", small: "" } },
                                        [_vm._v(" fas fa-eye ")]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      ["image", "document"].includes(_vm.whatsappMessageType)
                        ? _c(
                            "v-col",
                            { staticClass: "d-flex" },
                            [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.filesFiltered,
                                  rules: [_vm.$rules.REQUIRED],
                                  label:
                                    _vm.whatsappMessageType === "image"
                                      ? "Imagen"
                                      : "Documento",
                                  "item-value": "id",
                                  "item-text": "name",
                                },
                                model: {
                                  value: _vm.whatsappMessageMedia,
                                  callback: function ($$v) {
                                    _vm.whatsappMessageMedia = $$v
                                  },
                                  expression: "whatsappMessageMedia",
                                },
                              }),
                              _vm._v(" "),
                              _vm.whatsappMessageMedia
                                ? [
                                    _vm.whatsappMessageType === "image"
                                      ? _c(
                                          "v-tooltip",
                                          {
                                            attrs: { bottom: "" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function ({ on }) {
                                                    return [
                                                      _c(
                                                        "v-btn",
                                                        _vm._g(
                                                          {
                                                            staticClass:
                                                              "ml-2 my-auto",
                                                            attrs: {
                                                              text: "",
                                                              icon: "",
                                                            },
                                                            on: {
                                                              click:
                                                                _vm.onOpenModalImageViewer,
                                                            },
                                                          },
                                                          on
                                                        ),
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                dark: "",
                                                                small: "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " fas fa-image "
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              3777248559
                                            ),
                                          },
                                          [
                                            _vm._v(" "),
                                            _c("span", [_vm._v("Ver imagen")]),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.whatsappMessageType === "document"
                                      ? _c(
                                          "v-tooltip",
                                          {
                                            attrs: { bottom: "" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function ({ on }) {
                                                    return [
                                                      _c(
                                                        "v-btn",
                                                        _vm._g(
                                                          {
                                                            staticClass:
                                                              "ml-2 my-auto",
                                                            attrs: {
                                                              text: "",
                                                              icon: "",
                                                            },
                                                            on: {
                                                              click:
                                                                _vm.onOpenModalPreview,
                                                            },
                                                          },
                                                          on
                                                        ),
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                dark: "",
                                                                small: "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " fas fa-file-download "
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              1697338208
                                            ),
                                          },
                                          [
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v("Descargar documento"),
                                            ]),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.whatsappMessageType === "upload"
                        ? _c(
                            "v-col",
                            [
                              _c("v-file-input", {
                                attrs: {
                                  label: "Archivo",
                                  accept:
                                    "text/plain, application/pdf, application/vnd.ms-powerpoint, application/msword, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.openxmlformats-officedocument.presentationml.presentation, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                                  rules: [
                                    _vm.$rules.REQUIRED,
                                    _vm.fileType
                                      ? (v) =>
                                          (_vm.fileType &&
                                            v &&
                                            v.size < _vm.fileType.maxSize) ||
                                          `El archivo debe ser menor a ${
                                            _vm.fileType.maxSize / 1000000
                                          }MB`
                                      : true,
                                    (v) => {
                                      if (v && v.type.includes("image/")) {
                                        return "Tipo de archivo no válido"
                                      }
                                      return true
                                    },
                                  ],
                                  placeholder: "Seleccione archivo a enviar",
                                  "clear-icon": "fa-times",
                                  "truncate-length": "50",
                                  "prepend-icon": "",
                                  "show-size": "",
                                },
                                model: {
                                  value: _vm.fileContent,
                                  callback: function ($$v) {
                                    _vm.fileContent = $$v
                                  },
                                  expression: "fileContent",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.useMessageTemplate &&
      _vm.comment.type !== _vm.$activityTypes.EVENT &&
      (_vm.comment.type !== _vm.$activityTypes.WHATSAPP ||
        (_vm.comment.type === _vm.$activityTypes.WHATSAPP &&
          _vm.getTicket.is_bot_stopped))
        ? _c(
            "v-col",
            [
              _c("v-textarea", {
                staticClass: "expand",
                attrs: {
                  rules:
                    _vm.whatsappMessageType === "text"
                      ? [_vm.$rules.REQUIRED]
                      : [],
                  label:
                    _vm.whatsappMessageType === "text"
                      ? "Mensaje de texto"
                      : "Escribe un comentario...",
                  flat: "",
                  "auto-grow": "",
                  rows: "1",
                },
                model: {
                  value: _vm.comment.text,
                  callback: function ($$v) {
                    _vm.$set(_vm.comment, "text", $$v)
                  },
                  expression: "comment.text",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.comment.type === _vm.$activityTypes.EVENT
        ? _c(
            "v-col",
            [
              _c(
                "v-row",
                { staticClass: "py-0" },
                [
                  _c(
                    "v-col",
                    { staticClass: "py-0", attrs: { cols: "12" } },
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.eventTypes,
                          rules: [_vm.$rules.REQUIRED],
                          label: "Tipo de evento",
                        },
                        model: {
                          value: _vm.comment.event_type,
                          callback: function ($$v) {
                            _vm.$set(_vm.comment, "event_type", $$v)
                          },
                          expression: "comment.event_type",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    {
                      staticClass: "py-0",
                      attrs: {
                        cols: "12",
                        md: _vm.colFixed || 3,
                        lg: _vm.colFixed || 4,
                      },
                    },
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { staticClass: "d-flex", attrs: { cols: "3" } },
                            [
                              _c("p", { staticClass: "my-auto text-body-2" }, [
                                _vm._v("Fecha:"),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-col",
                            { attrs: { cols: "9" } },
                            [
                              _c(
                                "v-menu",
                                {
                                  attrs: {
                                    "close-on-content-click": false,
                                    "nudge-right": 40,
                                    transition: "scale-transition",
                                    "offset-y": "",
                                    "min-width": "300px",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on }) {
                                          return [
                                            _c(
                                              "v-text-field",
                                              _vm._g(
                                                {
                                                  staticClass: "mb-4",
                                                  attrs: {
                                                    placeholder: _vm.today,
                                                    readonly: "",
                                                    rules: [
                                                      _vm.$rules.REQUIRED,
                                                    ],
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.comment.date_start,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.comment,
                                                        "date_start",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "comment.date_start",
                                                  },
                                                },
                                                on
                                              )
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    878888140
                                  ),
                                  model: {
                                    value: _vm.menuDateStart,
                                    callback: function ($$v) {
                                      _vm.menuDateStart = $$v
                                    },
                                    expression: "menuDateStart",
                                  },
                                },
                                [
                                  _vm._v(" "),
                                  _c("v-date-picker", {
                                    on: {
                                      input: function ($event) {
                                        _vm.menuDateStart = false
                                      },
                                    },
                                    model: {
                                      value: _vm.comment.date_start,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.comment, "date_start", $$v)
                                      },
                                      expression: "comment.date_start",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-checkbox", {
                        attrs: { label: "Mostrar más campos" },
                        model: {
                          value: _vm.moreEventFields,
                          callback: function ($$v) {
                            _vm.moreEventFields = $$v
                          },
                          expression: "moreEventFields",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    { staticClass: "py-0 my-0", attrs: { cols: "12" } },
                    [
                      _vm.moreEventFields
                        ? _c(
                            "v-row",
                            { staticClass: "py-0" },
                            [
                              _c(
                                "v-col",
                                { staticClass: "py-0", attrs: { cols: "12" } },
                                [
                                  _c("v-textarea", {
                                    staticClass: "expand",
                                    attrs: {
                                      label:
                                        _vm.whatsappMessageType === "text"
                                          ? "Mensaje de texto"
                                          : "Escribe un comentario...",
                                      flat: "",
                                      "auto-grow": "",
                                      rows: "1",
                                    },
                                    model: {
                                      value: _vm.comment.text,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.comment, "text", $$v)
                                      },
                                      expression: "comment.text",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                { staticClass: "py-0", attrs: { cols: "12" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "mb-4",
                                    attrs: {
                                      label: "Nombre del evento",
                                      placeholder: " ",
                                    },
                                    model: {
                                      value: _vm.comment.event_name,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.comment, "event_name", $$v)
                                      },
                                      expression: "comment.event_name",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                {
                                  staticClass: "pt-0 pb-40",
                                  attrs: {
                                    cols: "12",
                                    md: _vm.colFixed || 8,
                                    lg: _vm.colFixed || 6,
                                  },
                                },
                                [
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "d-flex",
                                          attrs: { cols: "3" },
                                        },
                                        [
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "my-auto text-body-2 mr-0",
                                            },
                                            [_vm._v("Hora:")]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "pr-0",
                                          attrs: { cols: "4" },
                                        },
                                        [
                                          _c(
                                            "v-dialog",
                                            {
                                              ref: "dialogTimeStart",
                                              attrs: {
                                                "return-value":
                                                  _vm.comment.time_start,
                                                persistent: "",
                                                width: "290px",
                                              },
                                              on: {
                                                "update:returnValue": function (
                                                  $event
                                                ) {
                                                  return _vm.$set(
                                                    _vm.comment,
                                                    "time_start",
                                                    $event
                                                  )
                                                },
                                                "update:return-value":
                                                  function ($event) {
                                                    return _vm.$set(
                                                      _vm.comment,
                                                      "time_start",
                                                      $event
                                                    )
                                                  },
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function ({ on }) {
                                                      return [
                                                        _c(
                                                          "v-text-field",
                                                          _vm._g(
                                                            {
                                                              staticClass:
                                                                "mb-4",
                                                              attrs: {
                                                                label: "",
                                                                placeholder:
                                                                  "00:00",
                                                                readonly: "",
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.comment
                                                                    .time_start,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.comment,
                                                                      "time_start",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "comment.time_start",
                                                              },
                                                            },
                                                            on
                                                          )
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                1361747923
                                              ),
                                              model: {
                                                value: _vm.dialogTimeStart,
                                                callback: function ($$v) {
                                                  _vm.dialogTimeStart = $$v
                                                },
                                                expression: "dialogTimeStart",
                                              },
                                            },
                                            [
                                              _vm._v(" "),
                                              _vm.dialogTimeStart
                                                ? _c(
                                                    "v-time-picker",
                                                    {
                                                      attrs: {
                                                        "full-width": "",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.comment
                                                            .time_start,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.comment,
                                                            "time_start",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "comment.time_start",
                                                      },
                                                    },
                                                    [
                                                      _c("v-spacer"),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          attrs: {
                                                            text: "",
                                                            color: "primary",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              _vm.dialogTimeStart = false
                                                            },
                                                          },
                                                        },
                                                        [_vm._v(" Cancelar ")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          attrs: {
                                                            text: "",
                                                            color: "primary",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.$refs.dialogTimeStart.save(
                                                                _vm.comment
                                                                  .time_start
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                      Aceptar\n                    "
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "d-flex",
                                          attrs: { cols: "1" },
                                        },
                                        [
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "my-auto text-body-2",
                                            },
                                            [_vm._v("-")]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "4" } },
                                        [
                                          _c(
                                            "v-dialog",
                                            {
                                              ref: "dialogTimeEnd",
                                              attrs: {
                                                "return-value":
                                                  _vm.comment.time_end,
                                                persistent: "",
                                                width: "290px",
                                              },
                                              on: {
                                                "update:returnValue": function (
                                                  $event
                                                ) {
                                                  return _vm.$set(
                                                    _vm.comment,
                                                    "time_end",
                                                    $event
                                                  )
                                                },
                                                "update:return-value":
                                                  function ($event) {
                                                    return _vm.$set(
                                                      _vm.comment,
                                                      "time_end",
                                                      $event
                                                    )
                                                  },
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function ({ on }) {
                                                      return [
                                                        _c(
                                                          "v-text-field",
                                                          _vm._g(
                                                            {
                                                              staticClass:
                                                                "mb-4",
                                                              attrs: {
                                                                label: "",
                                                                placeholder:
                                                                  "01:00",
                                                                readonly: "",
                                                                rules: [
                                                                  (v) =>
                                                                    !_vm.comment
                                                                      .time_start ||
                                                                    v >=
                                                                      _vm
                                                                        .comment
                                                                        .time_start ||
                                                                    "Hora inválida",
                                                                ],
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.comment
                                                                    .time_end,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.comment,
                                                                      "time_end",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "comment.time_end",
                                                              },
                                                            },
                                                            on
                                                          )
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                3864722068
                                              ),
                                              model: {
                                                value: _vm.dialogTimeEnd,
                                                callback: function ($$v) {
                                                  _vm.dialogTimeEnd = $$v
                                                },
                                                expression: "dialogTimeEnd",
                                              },
                                            },
                                            [
                                              _vm._v(" "),
                                              _vm.dialogTimeEnd
                                                ? _c(
                                                    "v-time-picker",
                                                    {
                                                      attrs: {
                                                        min: _vm.comment
                                                          .time_start,
                                                        "full-width": "",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.comment.time_end,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.comment,
                                                            "time_end",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "comment.time_end",
                                                      },
                                                    },
                                                    [
                                                      _c("v-spacer"),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          attrs: {
                                                            text: "",
                                                            color: "primary",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              _vm.dialogTimeEnd = false
                                                            },
                                                          },
                                                        },
                                                        [_vm._v(" Cancelar ")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          attrs: {
                                                            text: "",
                                                            color: "primary",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.$refs.dialogTimeEnd.save(
                                                                _vm.comment
                                                                  .time_end
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [_vm._v(" Aceptar ")]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.responseErrorMessage
        ? _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "v-alert",
                { staticClass: "mb-0", attrs: { text: "", type: "error" } },
                [
                  _vm._v(
                    "\n      " + _vm._s(_vm.responseErrorMessage) + "\n    "
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.comment.type !== _vm.$activityTypes.WHATSAPP ||
      (_vm.comment.type === _vm.$activityTypes.WHATSAPP &&
        _vm.getTicket.is_bot_stopped)
        ? _c(
            "v-btn",
            {
              staticClass: "mt-2",
              attrs: {
                color: _vm.getCommentTypes[_vm.comment.type].color,
                block: "",
                outlined: "",
                depressed: "",
                loading: _vm.loading,
              },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.onComment.apply(null, arguments)
                },
              },
            },
            [
              _c("v-icon", { attrs: { left: "", dark: "" } }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.getCommentTypes[_vm.comment.type].icon) +
                    "\n    "
                ),
              ]),
              _vm._v("\n    Comentar\n  "),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.dialogPreview
        ? _c("ModalPreview", {
            attrs: {
              dialog: _vm.dialogPreview,
              "message-template-selected": _vm.messageTemplateSelected,
            },
            on: {
              "update:dialog": function ($event) {
                _vm.dialogPreview = $event
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.dialogImageViewer
        ? _c("ModalImageViewer", {
            attrs: {
              dialog: _vm.dialogImageViewer,
              url: _vm.messageMediaSelected,
            },
            on: {
              "update:dialog": function ($event) {
                _vm.dialogImageViewer = $event
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }